var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutterAc2Cb8C6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_flutter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6667 3.01667L3 19.6667L8.15 24.8167L12.6667 20.3167L29.9833 3L19.6667 3.01667ZM21.0333 27.35L30.0167 18.3833H20.1333C19.95 18.3833 19.7 18.3833 19.5667 18.5L15.85 22.2167L10.7 27.3333L15.85 32.5L19.4333 36.0833C19.55 36.2 19.6667 36.3667 19.8667 36.3333H29.9833L21.0333 27.35Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterAc2Cb8C6);
export default __webpack_public_path__ + "static/media/flutter-ac2cb8c6.13c58d99340e4dd827d53b8e7aa25f1c.svg";
export { ForwardRef as ReactComponent };